/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson, serverMsg } from '../lib/api.js';
import { PB_URL } from '../lib/config.js';
import { playBlip, playPop } from '../lib/sound.js';
import { parseTs } from '../lib/text.js';
import * as store from '../lib/store.js';

export default {
  // Drie hokjes: open, gedaan, afgewezen. Gedaan en afgewezen sluiten elkaar uit.
  featureStatusOf(f) { return f.declined ? 'declined' : f.solved ? 'done' : 'open'; },

  featureVisible() {
      const filter = this.state.featureFilter || 'open';
      const list = (this.state.featureList || []).filter((f) => this.featureStatusOf(f) === filter);
      return filter === 'open'
        ? list.sort((a, b) => (b.votes - a.votes) || (parseTs(b.created) - parseTs(a.created)))
        : list.sort((a, b) => parseTs(b.updated || b.created) - parseTs(a.updated || a.created));
    },

  async toggleSolved(id) {
      if (!this.isMaintainer) return;
      const list = this.state.featureList || [];
      const item = list.find((f) => f.id === id);
      if (!item) return;
      const solved = !item.solved;
      const patch = item.declined ? { solved, declined: false } : { solved };
      this.setState({ featureError: '', featureList: list.map((f) => (f.id === id ? { ...f, ...patch } : f)) });
      playPop();
      try {
        const res = await api(`${PB_URL}/api/collections/paal_feature_requests/records/${id}`, asJson('PATCH', patch));
        const rec = await res.json();
        if (!res.ok || !('solved' in rec)) throw new Error('veld');
      } catch (e) {
        this.setState({ featureError: 'Voeg op de server aan paal_feature_requests een Boolean-veld "solved" toe.' });
      }
    },

  async toggleDeclined(id) {
      if (!this.isMaintainer) return;
      const list = this.state.featureList || [];
      const item = list.find((f) => f.id === id);
      if (!item) return;
      const declined = !item.declined;
      // Afgewezen ideetjes horen niet ook als gedaan te blijven staan.
      const patch = declined ? { declined: true, solved: false } : { declined: false };
      this.setState({ featureError: '', featureList: list.map((f) => (f.id === id ? { ...f, ...patch } : f)) });
      playPop();
      try {
        const res = await api(`${PB_URL}/api/collections/paal_feature_requests/records/${id}`, asJson('PATCH', patch));
        const rec = await res.json();
        if (!res.ok || !('declined' in rec)) throw new Error('veld');
      } catch (e) {
        this.setState({ featureError: 'Voeg op de server aan paal_feature_requests een Boolean-veld "declined" toe.' });
      }
    },

  // One vote per account: the accountId is the key, so a rename keeps the vote.
  voteKey() { return (this.state.accountId || '').trim(); },

  localVotes() { try { return JSON.parse(store.get('gp_feature_votes') || '{}') || {}; } catch (e) { return {}; } },

  setLocalVote(id, on) {
      const map = this.localVotes();
      if (on) map[id] = 1; else delete map[id];
      store.set('gp_feature_votes', JSON.stringify(map));
    },

  async voteFeature(id) {
      if (!this.ensureName('Log in of maak een account aan om op de ideetjes te stemmen.')) return;
      const key = this.voteKey();
      const list = this.state.featureList || [];
      const item = list.find((f) => f.id === id);
      if (!item) return;
      const voters = (item.votedBy || '').split('\n').map((v) => v.trim()).filter(Boolean);
      const at = voters.indexOf(key);
      if (at >= 0) voters.splice(at, 1); else voters.push(key);
      const votedBy = voters.join('\n');
      const votes = voters.length;
      this.setLocalVote(id, at < 0);
      this.setState({ featureError: '', featureList: list.map((f) => (f.id === id ? { ...f, votedBy, votes } : f)) });
      if (at < 0) playPop();
      try {
        const res = await api(`${PB_URL}/api/collections/paal_feature_requests/records/${id}`, asJson('PATCH', { votes, votedBy }));
        if (!res.ok) throw new Error(res.status);
        const rec = await res.json();
        if (typeof rec.votes !== 'number' && (rec.votedBy || '') !== votedBy) throw new Error('velden');
      } catch (e) {
        // Server can't store votes yet, so keep the local count instead of snapping back.
        this.setState({ featureNote: 'Je stem is voorlopig alleen op dit apparaat bewaard.' });
      }
    },

  onFeatureInput(e) { return this.setState({ featureText: e.target.value }); },

  async submitFeature() {
      if (!this.ensureName('Log in of maak een account aan om een ideetje in te sturen.')) return;
      const text = (this.state.featureText || '').trim();
      if (!text) { this.setState({ featureError: 'Schrijf eerst je ideetje op.' }); return; }
      this.setState({ featureSending: true, featureError: '' });
      try {
        const res = await api(`${PB_URL}/api/collections/paal_feature_requests/records`, asJson('POST', { text, author: this.state.author || '', authorId: this.state.accountId || '' }));
        if (!res.ok) {
          throw new Error(await serverMsg(res));
        }
        playBlip();
        this.setState({ featureSending: false, featureSent: true, featureText: '' }, this.fetchFeatures);
      } catch (err) {
        this.setState({ featureSending: false, featureError: 'Versturen mislukt: ' + err.message + '. Bestaat de collectie paal_feature_requests met velden text en author?' });
      }
    }
};
